import React from 'react';
import { useCookieConsentContext } from './CookieConsentProvider';
import { useLanguage } from '../../hooks/useLanguage';

const CustomBanner: React.FC = () => {
  const { consentState, acceptAll, rejectAll, hasMadeChoice } = useCookieConsentContext();
  const { t } = useLanguage();

  // Don't show the banner if user has already made a choice
  if (hasMadeChoice) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4 md:p-6 cookie-banner-enter">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {t('landing.cookieBanner.title')}
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              {t('landing.cookieBanner.description')}
            </p>
            <div className="mt-3 text-xs text-gray-500">
              <a 
                href="/privacy-policy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline mr-4 transition-colors"
              >
                {t('landing.cookieBanner.privacyPolicy')}
              </a>
              <a 
                href="/terms-and-conditions" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline transition-colors"
              >
                {t('landing.cookieBanner.termsAndConditions')}
              </a>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={rejectAll}
              className="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-200 hover:shadow-sm"
            >
              {t('landing.cookieBanner.rejectAll')}
            </button>
            <button
              onClick={acceptAll}
              className="px-6 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 hover:shadow-sm"
            >
              {t('landing.cookieBanner.acceptAll')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomBanner; 